export default function TextField(theme) {
  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          height: 'unset',
          width: '100%',
        },
      },
    },
  };
}
